import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanReleasesRoute: InvariantJiraRoute = {
	name: 'software-plan-releases',
	path: '/jira/plans/:planId/scenarios/:scenarioId/releases',
};
